module.exports = __webpack_public_path__ + "img/footer-img3.ab616457.jpg";